import { Model } from "@rematch/core";
import { IWeworkMember } from "shared/model/IWeworkMember";
import { WeworkCampaignPageParams } from "shared/pages/WeworkCampaignPage";

import { IRefreshablePropSubState } from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { reloadMember } from "./WeworkEffects";

export interface IWeworkModel extends Model {
  name: StateModules;
  state: IWeworkState;
  reducers: IWeworkReducers;
  effects: IWeworkEffects;
}

export type IWeworkState = {
  currentMemberId?: string;
  currentMember: IRefreshablePropSubState<IWeworkMember>;
};

export type IWeworkReducers = {
  reloadingMember: (
    state: IWeworkState,
    params: WeworkCampaignPageParams
  ) => IWeworkState;
  reloadMemberSucceeded: (
    state: IWeworkState,
    params: { member: IWeworkMember }
  ) => IWeworkState;
  reloadMemberFailed: (state: IWeworkState, error: string) => IWeworkState;
};

export type IWeworkEffects = {
  reloadMember: (params: WeworkCampaignPageParams, state: IState) => void;
};

export type IWeworkDispatch = {
  reloadMember: (params: WeworkCampaignPageParams) => void;
  reloadingMember: (params: WeworkCampaignPageParams) => void;
  reloadMemberSucceeded: (params: { member: IWeworkMember }) => void;
  reloadMemberFailed: (error: string) => void;
};

export const WeworkModule: IWeworkModel = {
  name: "weworkCampaign",
  state: {
    currentMember: {
      isFetching: true
    }
  },
  reducers: {
    reloadingMember: (
      state: IWeworkState,
      params: WeworkCampaignPageParams
    ): IWeworkState => ({
      ...state,
      currentMemberId: params.id,
      currentMember: {
        isFetching: true,
        error: undefined
      }
    }),
    reloadMemberSucceeded: (
      state: IWeworkState,
      params: { member: IWeworkMember }
    ): IWeworkState => ({
      ...state,
      currentMember: {
        isFetching: false,
        prop: params.member
      }
    }),
    reloadMemberFailed: (state: IWeworkState, error: string): IWeworkState => ({
      ...state,
      currentMember: {
        isFetching: false,
        error
      }
    })
  },
  effects: {
    reloadMember
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/wework/WeworkModule.ts